import React, {useCallback} from 'react';
import DatePicker from 'react-datepicker';
import styled from 'styled-components';
import {DateTime, Format} from '@cabinetsbycomputer/datetime';
import {DatePickerHeader} from 'shared/components/DatePickerHeader';

import 'react-datepicker/dist/react-datepicker.css';

interface RequestedDeliveryDatePickerProps {
    value?: string;
    onChange: (value: string) => void;
    minimumLeadTime?: number;
    isInvalid?: boolean;
    id?: string;
    placeholder?: string;
}

export const RequestedDeliveryDatePicker = ({
    value,
    onChange,
    minimumLeadTime = 0,
    isInvalid = false,
    id,
    placeholder = 'Select a delivery date',
}: RequestedDeliveryDatePickerProps) => {
    const handleChange = useCallback(
        (date: Date | null) => {
            if (date) {
                onChange(
                    DateTime.fromDate(date).format(Format.Date).toString()
                );
            }
        },
        [onChange]
    );

    const preventDefault = useCallback(
        (event: React.KeyboardEvent<HTMLElement>) => event.preventDefault(),
        []
    );

    return (
        <StyledPicker>
            <DatePicker
                id={id}
                popperPlacement="bottom-start"
                renderCustomHeader={DatePickerHeader}
                showIcon
                className={`form-control${isInvalid ? ' is-invalid' : ''}`}
                wrapperClassName="full-width"
                dateFormat="dd MMM yyyy"
                selected={(value && DateTime.parseCustom(value).get()) || null}
                placeholderText={placeholder}
                minDate={DateTime.now().add({days: minimumLeadTime}).get()}
                onChange={handleChange}
                onKeyDown={preventDefault}
                toggleCalendarOnIconClick
            />
        </StyledPicker>
    );
};

export const StyledPicker = styled.div`
    .react-datepicker__triangle {
        transform: rotate(180deg) translate(110px, -1px) !important;
    }
    .react-datepicker__input-container {
        display: flex;
        align-items: center;
        flex-direction: row-reverse;
        input {
            padding: 6px 32px 6px 12px;
        }
        svg path {
            fill: rgb(var(--primary_colour));
        }
    }
    .react-datepicker__day--selected {
        background-color: rgb(var(--primary_colour));
    }
`;
